import { CLEAR_OBJECT_STACK } from "./actionTypes";

export default (objectType) => ({
  type: CLEAR_OBJECT_STACK,
  payload: {
    objectType,
  }
});